

import type { ValidChainId } from "@types";
import { chainography } from "../../package.json";
import {
	isValidChainId,
	isURL,
	type URL,
} from "@bracket/chainography/types";
import { runtime, } from "./runtime";


/**
 * Obtain an RPC in a number of ways we do it, erroring if one cannot be resolved unless set in silent mode.
 * @param {number} chain chain identifier
 * @param {boolean} silent return null rather than error if an RPC cannot be located.
 * @returns {`http${string}`} the RPCURL
 */
export const getRPCURL = ( chain: ValidChainId, silent = false): URL => {
	try {
		if(isValidChainId(chain)) {
			if(runtime() === "BROWSER") {
				const { hostname, } = globalThis.location;
				// ensure all bracket.fi hosted web apps get the production URL EXCEPT FOR STAGING.
				if(hostname.endsWith(".bracket.fi") && !hostname.startsWith("staging")) {
					const { VITE_APP_ALCHEMY_API_KEY, } = import.meta.env;
					if(VITE_APP_ALCHEMY_API_KEY) {
						if(chain === 1) return `https://eth-mainnet.g.alchemy.com/v2/${VITE_APP_ALCHEMY_API_KEY}`;
						if(chain === 42161) return `https://arb-mainnet.g.alchemy.com/v2/${VITE_APP_ALCHEMY_API_KEY}`;
						throw new Error(`no RPC URL is set for invalid chain ${chain}`);
					}
					throw new Error(`host ${hostname} does not have VITE_APP_ALCHEMY_API_KEY set.`);
				}
				const url = chainography[`CHAIN_${chain}_RPC`];
				if(isURL(url)) {
					console.log(`browser development environment [chain:${chain}] using ${url}`);
					return url;
				}
				throw new Error(`@bracket/chainography configuration (package.json) does not have a dev chain set for chain ${chain}`)
			}

			if(runtime() === "NODE") {
				const url = globalThis.process.env[`CHAIN_${chain}_RPC`] || chainography[`CHAIN_${chain}_RPC`];
				if(isURL(url)) {
					return url;
				}
				throw new Error(`node environment failed to obtain a valid RPC on chain ${chain}`)
			}

			throw new Error(`unknown runtime ${runtime()} - expect either NODE or BROWSER`);

		}
		throw new Error(`invalid/unsupported chain ${chain}`)
	}
	catch( err ) {
		if(silent) return null;
		throw new Error(`@bracket/chainography::getRPCURL failed - ${err.message}`);
	}
}
